import createMarker from './createMarker'

const updatePins = function (
    props,
    mapLocations,
    pins,
    markerThemeExtractor,
    currentMapTheme,
    highlightLocation,
    map,
    updateMarkerHighlight
) {
    const hoverEnterLocation =
        props.hoverEnterLocation ??
        function (location) {
            highlightLocation.value = location
            if (pins.value !== null) {
                updateMarkerHighlight()
            }
        }
    const hoverLeaveLocation =
        props.hoverLeaveLocation ??
        function () {
            highlightLocation.value = undefined
            if (pins.value !== null) {
                updateMarkerHighlight()
            }
        }
    const clickLocation =
        props.clickLocation ??
        function (location) {
            window.location.href = location.centerPageUrl
        }

    mapLocations.value.forEach((location) => {
        pins.value.push({
            marker: createMarker(
                location,
                markerThemeExtractor,
                currentMapTheme,
                hoverEnterLocation,
                hoverLeaveLocation,
                clickLocation,
                highlightLocation,
                map
            ),
            location,
        })
    })

    return pins.value
}

export default updatePins
